<template>
    <div></div>
</template>

<script>
    var Vue = require('vue/dist/vue.js');

    export default {
        name: 'catalog-page',
        props: {
            page_id: {default: null},
        },
        data: function() {
            return {
                vue: null,
            };
        },
        watch: {
            page_id(newVal) {
                this.refresh(newVal);
            }
        },
        methods: {
            refresh(page_id)
            {
                this.$http.get('/api/catalog/page/' + page_id).then(response => {

                    if(this.vue !== null)
                    {
                        this.vue.$destroy(true);
                        this.vue.$el.remove();
                    }
                    let div = document.createElement('div');
                    this.$el.appendChild(div);
                    this.vue = new Vue({
                        el: div,
                        template: '<div>' + response.data.content + '</div>',
                    });
                });
            }
        },
        mounted()
        {
            this.refresh(this.page_id);
        },
        beforeDestroy()
        {
            this.vue.$destroy(true);
        }
    }
</script>
